<template>
  <el-dialog :model-value="show"
             class="cus-el-dialog"
             :append-to-body="false"
             width="800"
             height="600"
             :before-close="handleClose">
    <template #header="{ close }">
      <div class="my-header">
        <p class="text-center font18">Personal resignation decisions</p>
      </div>
    </template>
    <el-scrollbar>
      <div class="font12 sp-color-11 pd-l-20 pd-r-20">
        <span><span class="sp-color-18">Organization name：</span>Joinocean shipbrokers ltd（Hongkong）</span>
        <span class="mg-l-30"><span class="sp-color-18">Department：</span>SH2(Shanghai,China)</span>
        <div class="info-panel">
          <p class="italic sp-color-18">About the organization</p>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Name') }}:</div>
            <div class="flex-1">Joinocean shipbrokers ltd 上海津洋航运经纪有限公司</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Registry') }}:</div>
            <div class="flex-1">China / Shanghai /Rm 3004,707 zhangyangRoad,Sinolife Tower ,Shanghai ,PRC
              China / Shanghai /Rm 3004,707 zhangyangRoad,Sinolife Tower ,Shanghai ,PRC</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Website') }}:</div>
            <div class="flex-1">www.shiplus.com</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Asssts/ Business volume') }}:</div>
            <div class="flex-1">Own (or partially own) about 10 Ships (Vessels) with about 100 metric tons (Deadweight)</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Business Covered') }}:</div>
            <div class="flex-1">China / Singapore</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Shiplus access identity') }}:</div>
            <div class="flex-1">Charterers</div>
          </div>

          <p class="italic sp-color-18 mg-t-30">About the business team</p>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Name') }}:</div>
            <div class="flex-1">Joinocean shipbrokers ltd 上海津洋航运经纪有限公司</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Office location') }}:</div>
            <div class="flex-1">China / Shanghai /Rm 3004,707 zhangyangRoad,Sinolife Tower ,Shanghai ,PRC</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Website') }}:</div>
            <div class="flex-1">www.shiplus.com</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Asssts/ Business volume') }}:</div>
            <div class="flex-1">Own (or partially own) about 10 Ships (Vessels) with about 100 metric tons (Deadweight)</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Contacts') }}:</div>
            <div class="flex-1">Email:Joinocean@Shiplus.com / Tel(Rep):+86 23 67804909</div>
          </div>
          <div class="flex-jc-start">
            <div class="item-title sp-color-18">{{ $l('Shiplus access identity') }}:</div>
            <div class="flex-1">Charterers</div>
          </div>
        </div>
        <div class="flex-jc-bt pd-30 ">
          <SpButton :width="109" :height="50" type="back" circle-radius="7" @click="toSold">
            {{ $l('Back') }}
          </SpButton>
          <SpButton :width="325" :height="50" type="primary" circle-radius="7" @click="toSold">
            {{ $l('Decided to leave') }}  <span class="company-name">Joinocean shipbrokers ltd</span>
          </SpButton>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { cargoOrderTctInformationdAllApi } from '../../../request/APIs/boAndOp'
import SpDivider from '../SpDivider'
import SpButton from '@/components/common/SpButton'

export default {
  name: 'ConfirmDimission',
  components: { SpButton, SpDivider },
  props: {
    show: Boolean,
    info: Object
  },

  emits: ['close'],
  setup (props, ctx) {
    const handleClose = () => {
      ctx.emit('close')
    }
    const fullTerm = ref('')
    watch(() => props.show, nv => {
      if (nv) {
        // getCargoOrderDetail()
      }
    })
    const getCargoOrderDetail = () => {
      cargoOrderTctInformationdAllApi(props.orderId).then(res => {
        if (res.code === 1) {
          fullTerm.value = res.data.term.content
        }
      })
    }
    return {
      fullTerm,
      getCargoOrderDetail,
      handleClose
    }
  }
}
</script>

<style scoped lang="less">
.info-panel {
  margin-top: 30px;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  padding: 12px 24px;
  .flex-jc-start {
    margin-bottom: 10px;
  }
  .item-title {
    width: auto;
    margin-right: 4px;
  }
}
.company-name {
  margin-left: 4px;
  text-decoration: underline;
  font-weight: 700;
}
</style>
